import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { view02ImageOptions } from './views/View02'

class X43BowSprit extends Component {
    constructor(props) {
        super(props);
        this.handleBowspritChange = this.handleBowspritChange.bind(this);
    }


    handleBowspritChange(newValue) {
        let configuration = this.props.configuration;
        configuration.BowSprit = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = view02ImageOptions;

        let image = <ConfiguratorImage boat="X4_3" configuration={this.props.configuration} options={imageOptions} />;
        
        return (
            <ConfiguratorSection image={image}>
                
                <ConfiguratorOption>
                    <h1><Trans defaults='Bowsprit' /></h1>

                    <p><Trans defaults='Hull topsides include 6 large hull portlights and a hull recessed anchor fitting hidden by GRP cowl, exchangeable with a carbon bowsprit to handle asymmetric spinnakers. This is a unique X-Yachts feature unparalleled by the competition.' /></p>

                    <RadioGroup label={this.props.t("Optional bowsprits in hull colour:")} options={this.props.bowSpritOptions} value={this.props.configuration.BowSprit} onChange={this.handleBowspritChange} />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X43BowSprit);


// WEBPACK FOOTER //
// ./src/X43/X43BowSprit.js